var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickupTruckDefault = function SvgPickupTruckDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 14.592,
    r: 1.121,
    stroke: "#1E242F",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.906,
    cy: 14.592,
    r: 1.121,
    stroke: "#1E242F",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M25.513 7.407c1.924 0 4.44-.004 6.278-.002.326 0 .504-.376.285-.617C31.13 5.745 30.062 4.872 29 4.466c-1.397-.534-2.782-.562-3.856-.594a.39.39 0 0 0-.404.39v2.371c0 .427.346.774.773.774Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m10.107 14.643-2.971-.738a.51.51 0 0 1-.382-.415l-.066-.401a3.87 3.87 0 0 1 .358-2.353v0a.4.4 0 0 0 .039-.208l-.2-2.175a.774.774 0 0 1 .771-.845h14.485a.774.774 0 0 0 .774-.773v-3.3c0-.426.344-.772.77-.774l5.187-.02q.127-.001.246.044c.537.21 2.81 1.222 5.126 4.007a.8.8 0 0 0 .553.291c.965.083 3.851.372 6.772 1.082.136.034.247.114.289.248.24.775.766 3.619-.227 5.536a.7.7 0 0 1-.502.353l-2.45.441m-22.629-.05h16.943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M15.835 14.594a2.655 2.655 0 1 1-5.311 0 2.655 2.655 0 0 1 5.31 0ZM38.561 14.594a2.655 2.655 0 1 1-5.31 0 2.655 2.655 0 0 1 5.31 0Z"
  })));
};
export default SvgPickupTruckDefault;